// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1c5XZ","title":"BackImages_title__1o2zz","images":"BackImages_images__3SCGj"};